import { socket } from "../services/sockets";
import {
  crearProyecto,
  registrarCreditosUsados,
  registrarUserInput,
} from "../controllers/operaciones";
import { NumeroEtapaFinal } from "../config/enums/enums";
import { iDataStateJobs } from "../interfaces/iDataStateJobs";
import { iDataResultadoLLMABP } from "../interfaces/iDataResultadoLLMABP";
import { iDataResultadoLLMAulaActiva } from "../interfaces/iDataResultadoLLMAulaActiva";

interface iDataJobProcessServerResponse {
  id: string;
}

/**
 *
 * @param data
 * @param stateJob
 * @param setStateJob
 * Función asociada a la suscripcion del socket cuando is ${prefix}_started
 */
const handleJobStarted = (
  data: iDataJobProcessServerResponse,
  stateJob: iDataStateJobs,
  setStateJob: React.Dispatch<React.SetStateAction<iDataStateJobs>>
) => {
  console.log("handleJobStarted", { data });
  const { propuestaUsuario, etapa } = stateJob;
  const nombreProyecto =
    propuestaUsuario.nombre ||
    `${propuestaUsuario.nivel_curso} propuesta de planificación`;
  setStateJob((prevState: iDataStateJobs) => ({
    ...prevState,
    jobs: {
      id: data.id,
      status: "Iniciado",
      title: nombreProyecto,
      etapa,
      tipoEstructura: stateJob.tipoEstructura,
    },
    showNotification: false,
    isCompleted: false,
    isFailed: false,
    isProcessing: true,
  }));
};

/**
 *
 * @param data
 * @param stateJob
 * @param setStateJob
 * @returns
 * * Función asociada a la suscripcion del socket cuando ${prefix}_finished
 */
const handleJobFinished = async (
  data: string,
  stateJob: iDataStateJobs,
  setStateJob: React.Dispatch<React.SetStateAction<iDataStateJobs>>,
  updateCreditInfo: () => Promise<void>
) => {
  console.log("handleJobFinished", { data });
  const {
    etapa,
    userId,
    propuestaUsuario,
    tipoEstructura,
    idOrganizacion,
  } = stateJob;
  console.log("handleJobFinished stateJob", stateJob);

  // Helper funcion para actualizar stateJob
  const updateStateJob = (updates: any) => {
    setStateJob((prevState: iDataStateJobs) => ({
      ...prevState,
      ...updates,
    }));
  };

  const resultado = JSON.parse(data);
  console.log("resultado", resultado);

  // Crear el proyecto si es la etapa inicial
  if (etapa === 0) {
    try {
      const proyectoId = await crearProyecto(
        userId,
        idOrganizacion,
        resultado.id,
        propuestaUsuario,
        tipoEstructura
      );
      //Guardamos los parametros de entrada del usuario
      await registrarUserInput(proyectoId, propuestaUsuario, etapa);
      updateStateJob({ proyectoId });
    } catch (error) {
      console.error("Error creating project:", error);
      return;
    }
  }

  //***Se agrega por la inconsistencia en la respuesta del backend idealmente cambiar desde el backend***
  const objRespuesta: iDataResultadoLLMABP | iDataResultadoLLMAulaActiva =
    tipoEstructura === "unidad_activa" && etapa == 1
      ? { ...resultado, propuestas: { plan_academico: resultado.propuestas } }
      : resultado;
  console.log("objRespuesta", objRespuesta);
  updateStateJob({
    wsProject: objRespuesta,
    showNotification: true,
    isCompleted: true,
    isFailed: false,
    isProcessing: false,
  });

  updateJobStatus(etapa, "Completado", objRespuesta, setStateJob);

  const { in_tokens, out_tokens, costo } = resultado;

  if (in_tokens && out_tokens ) {
    try {
      await registrarCreditosUsados(userId, in_tokens, out_tokens, costo);
      setStateJob((prevState: iDataStateJobs) => ({
      ...prevState,
      in_tokens,
      out_tokens,
      costo,
    }));
    } catch (error) {
      console.error("Error registering credits used:", error);
    }
  }
  //Verificamos  si el proyecto llego a su etapa final
  if (
    NumeroEtapaFinal[tipoEstructura as keyof typeof NumeroEtapaFinal] == etapa
  ) {
    console.log("etapa final detectada");
    await updateCreditInfo();
    setStateJob((prevState: iDataStateJobs) => ({
      ...prevState,
      isProjectFinished: true,
      showNotification: true,
    }));
  }
};

/**
 *
 * @param data
 * @param stateJob
 * @param setStateJob
 * Función asociada a la suscripcion del socket cuando is ${prefix}_failed
 */
const handleJobFailed = (
  data: iDataJobProcessServerResponse,
  stateJob: iDataStateJobs,
  setStateJob: React.Dispatch<React.SetStateAction<iDataStateJobs>>
) => {
  console.log("handleJobFailed", { data });
  const { etapa } = stateJob;
  console.log(`on failed: ${data}`);
  updateJobStatus(etapa, "Failed", {}, setStateJob);
  setStateJob((prevState: iDataStateJobs) => ({
    ...prevState,
    showNotification: true,
    isFailed: true,
    isProcessing: false,
  }));
};

/**
 *
 * @param etapa
 * @param newStatus
 * @param resultado
 * @param setStateJob
 * Actualiza el estado del job
 */
const updateJobStatus = (
  etapa: number,
  newStatus: string,
  resultado: any,
  setStateJob: React.Dispatch<React.SetStateAction<iDataStateJobs>>
) => {
  console.log(
    `updateJobStatus on finished newStatus=${newStatus} proyecto=${resultado}, etapa=${etapa}`
  );
  setStateJob((prevState: iDataStateJobs) => ({
    ...prevState,
    jobs: {
      ...prevState.jobs,
      status: newStatus,
      etapa: etapa,
      proyecto: resultado,
    },
  }));
};

/**
 *
 * @param prefix
 * @param stateJob
 * @param setStateJob
 * @returns
 */
//Eventos a los cuales se suscribe el sockets
export const subscribeToEvents = (
  prefix: string,
  stateJob: iDataStateJobs,
  setStateJob: React.Dispatch<React.SetStateAction<iDataStateJobs>>, 
  updateCreditInfo: () => Promise<void>
) => {
  socket?.on(`${prefix}_started`, (data) =>
    handleJobStarted(data, stateJob, setStateJob)
  );
  socket?.on(`${prefix}_finished`, (data) =>
    handleJobFinished(data, stateJob, setStateJob,updateCreditInfo)
  );
  socket?.on(`${prefix}_failed`, (data) =>
    handleJobFailed(data, stateJob, setStateJob)
  );
  socket?.on("error", (err) => console.error("Error:", err));
  socket?.on("connect", () => console.log("Conectado al servidor"));
  return socket;
};

/**
 *
 * @param subscription
 * @param prefix
 */
export const unsubscribeFromEvents = (subscription: any, prefix: string) => {
  subscription.off(`${prefix}_started`);
  subscription.off(`${prefix}_finished`);
  subscription.off(`${prefix}_failed`);
  subscription.off("error");
  subscription.off("connect");
};
